var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWalletWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none",
  viewBox: "0 0 16 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.33,
  d: "M13.125 6.157h1.517l.044.008a.09.09 0 0 1 .056.082v1.526c0 .04-.034.088-.1.09h-1.428c-.506 0-.902-.37-.936-.775l-.001-.008-.004-.095a.83.83 0 0 1 .25-.574l.013-.011a.81.81 0 0 1 .59-.243Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.273 9.64h-1.059c-1.407 0-2.592-1.06-2.71-2.408-.067-.77.214-1.54.777-2.088a2.55 2.55 0 0 1 1.844-.763h1.148c.215 0 .393-.178.37-.393-.162-1.8-1.355-3.03-3.125-3.237a3.4 3.4 0 0 0-.555-.037H4.297q-.312 0-.6.045C1.807.996.593 2.403.593 4.418v5.184a3.705 3.705 0 0 0 3.704 3.704h6.666c2.074 0 3.503-1.296 3.68-3.274a.364.364 0 0 0-.37-.393M8.741 5.342H4.297a.56.56 0 0 1-.556-.555.56.56 0 0 1 .556-.556H8.74a.56.56 0 0 1 .555.556.56.56 0 0 1-.555.555"
})));
export default SvgWalletWhite;